document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tabs-section').forEach(section => {
      const flkty = new Flickity(section.querySelector('.tabs-images'), {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false
      });

      // Tabs
      section.querySelectorAll('.tabs li').forEach(tab => {
        tab.addEventListener('click', function (e) {
          e.stopPropagation();
          const index = parseInt(this.getAttribute('data-index'));
          flkty.select(index);
        });
      });

      // Navigation
      section.querySelector('.tabs-prev').addEventListener('click', function (e) {
        flkty.previous();
      });

      section.querySelector('.tabs-next').addEventListener('click', function (e) {
        flkty.next();
      });

      // Flickity select event
      flkty.on('select', function () {
        const index = flkty.selectedIndex;

        // Update tabs
        section.querySelectorAll('.tabs li').forEach((tab, i) => {
          tab.classList.toggle('is-active', i === index);
        });

        // Update counter
        section.querySelector('.tabs-current').textContent = index + 1;

        // Animate text
        const texts = section.querySelectorAll('.tabs-texts .tab-text');

        texts.forEach((text, i) => {
          if (i === index) {
            text.classList.add('is-active');
          } else {
            text.classList.remove('is-active');
          }
        });
      });
    });

    setTabsHeight();
});

function setTabsHeight() {
  const elements = document.querySelectorAll('.tabs-section .tab-text');

  // Reset heights
  elements.forEach(el => {
      el.style.height = 'auto';
  });

  // Get tallest height
  let maxHeight = 0;
  elements.forEach(el => {
      const elHeight = el.offsetHeight;
      if (elHeight > maxHeight) {
          maxHeight = elHeight;
      }
  });

  console.log(maxHeight);

  // Set all to tallest height
  elements.forEach(el => {
      el.style.height = maxHeight + 'px';
  });
}

window.addEventListener('resize', () => {
  setTabsHeight();
});